export default "__VITE_ASSET__B7DJEc0S__"